import { render, staticRenderFns } from "./DetailedDiscountReport.vue?vue&type=template&id=d53bb9c0"
import script from "./DetailedDiscountReport.vue?vue&type=script&lang=js"
export * from "./DetailedDiscountReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports